import request from '@/utils/request'

// 校园服务
// 通知信息 Article/notificationInformation
export function notificationInformation(data) {
  return request({
    method: 'get',
    url: 'Article/notificationInformation',
    params: data
  })
}

//   膳食公示 Article/dietPublicity
export function dietPublicity(data) {
  return request({
    method: 'get',
    url: 'Article/dietPublicity',
    params: data
  })
}

//   卫生保健 Article/healthCare
export function healthCare(data) {
  return request({
    method: 'get',
    url: 'Article/healthCare',
    params: data
  })
}

//   交通服务 Article/transportServices
export function transportServices(data) {
  return request({
    method: 'get',
    url: 'Article/transportServices',
    params: data
  })
}

//   周末托管 Article/weekendHosting
export function weekendHosting(data) {
  return request({
    method: 'get',
    url: 'Article/weekendHosting',
    params: data
  })
}

//   安全教育 Article/safetyEducation
export function safetyEducation(data) {
  return request({
    method: 'get',
    url: 'Article/safetyEducation',
    params: data
  })
}

// 服务指南 Article/serviceInformation

export function serviceInformation(data) {
  return request({
    method: 'get',
    url: 'Article/serviceInformation',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/Article.js